// import React, { useState } from 'react'
// import Footer from '../components/Footer'
// import ApplyImg from "../assets/images/admission.jpeg";
// import AmazonImg from "../assets/amazon.jpg";
// import IbmImg from "../assets/ibm.jpg";
// import CiscoIMG from "../assets/cicsco.jpg";
// import ItImg from "../assets/It.jpg";
// import TataIMG from "../assets/tata.jpg";
// import GodrejImg from "../assets/godrej.jpg";
// import SubFooter from '../components/SubFooter';

// const stats = [
//     { id: 1, name: 'Highest Package', value: '43.5 Lakh' },
//     { id: 2, name: 'Average Package', value: '5.48 Lakh' },
//     { id: 3, name: 'Years of Legacy', value: '14' },
// ]

// const ApplyNow = () => {
//     const [formData, setFormData] = useState({
//         name: '',
//         email: '',
//         mobile: '',
//         state: '',
//         course: ''
//       });

//       const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prevState => ({
//           ...prevState,
//           [name]: value
//         }));
//       };

//       const handleSubmit = (e) => {
//         e.preventDefault();
//         // Add form submission logic here
//         console.log('Form submitted:', formData);
//       };
//     return (
//         <div className=' w-full relative' >
//             <div>
//                 <img src={ApplyImg} className=' w-full mb-[30px] mt-[50px] md:mt-[80px] ' />
//             </div>
//             <div className=' w-10/12 mx-auto flex flex-col gap-5 mb-[50px] ' >
//                 <h2 className={` mb-4 text-2xl md:text-5xl tracking-tight font-bold text-center mt-5 md:mt-10 uppercase text-[#0e4d38]`}>Ready for a bright future?</h2>
//                 <div className=' w-[15%] mx-auto h-[4px] bg-[#23376c] mt-[-10px] md:mt-[-5px] ' ></div>
//                 <p className=' text-center text-xl mt-5 md:mt-8 ' >Complete your <strong>online application</strong> and begin your journey to a college where you truly belong.</p>
//                 <p className=' text-center md:mt-[-10px] text-lg text-[#23376c] '>Simply create an account or log in to continue a previous application.</p>

//                 <div className="flex items-center justify-center w-full h-full mt-10 ">
//                     <div className=' w-full mx-auto flex justify-center rounded-md ' >
//                         <div className="p-8 bg-white shadow-2xl rounded-xl border border-gray-100 max-w-md w-full">
//                             <div className="text-center mb-6">
//                                 <h2 className="text-3xl font-bold text-[#0e4d38] mb-2">
//                                     Registrations Open 2024
//                                 </h2>
//                                 <p className="text-gray-600">Begin your academic journey</p>
//                             </div>

//                             <form onSubmit={handleSubmit}>
//                                 <div className="space-y-4">
//                                     <div className="relative">
//                                         <label
//                                             htmlFor="name"
//                                             className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-500"
//                                         >
//                                             Full Name
//                                         </label>
//                                         <input
//                                             type="text"
//                                             id="name"
//                                             name="name"
//                                             value={formData.name}
//                                             onChange={handleChange}
//                                             placeholder="Enter your full name"
//                                             required
//                                             className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0e4d38]/50 transition duration-200"
//                                         />
//                                     </div>

//                                     <div className="relative">
//                                         <label
//                                             htmlFor="email"
//                                             className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-500"
//                                         >
//                                             Email Address
//                                         </label>
//                                         <input
//                                             type="email"
//                                             id="email"
//                                             name="email"
//                                             value={formData.email}
//                                             onChange={handleChange}
//                                             placeholder="Enter your email"
//                                             required
//                                             className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0e4d38]/50 transition duration-200"
//                                         />
//                                     </div>

//                                     <div className="relative">
//                                         <label
//                                             htmlFor="mobile"
//                                             className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-500"
//                                         >
//                                             Mobile Number
//                                         </label>
//                                         <input
//                                             type="tel"
//                                             id="mobile"
//                                             name="mobile"
//                                             value={formData.mobile}
//                                             onChange={handleChange}
//                                             placeholder="Enter your mobile number"
//                                             required
//                                             className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0e4d38]/50 transition duration-200"
//                                         />
//                                     </div>

//                                     <div className="relative">
//                                         <label
//                                             htmlFor="state"
//                                             className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-500"
//                                         >
//                                             State
//                                         </label>
//                                         <input
//                                             type="text"
//                                             id="state"
//                                             name="state"
//                                             value={formData.state}
//                                             onChange={handleChange}
//                                             placeholder="Enter your state"
//                                             required
//                                             className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0e4d38]/50 transition duration-200"
//                                         />
//                                     </div>

//                                     <div className="relative">
//                                         <label
//                                             htmlFor="course"
//                                             className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-500"
//                                         >
//                                             Course of Interest
//                                         </label>
//                                         <input
//                                             type="text"
//                                             id="course"
//                                             name="course"
//                                             value={formData.course}
//                                             onChange={handleChange}
//                                             placeholder="Enter course you're applying for"
//                                             required
//                                             className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#0e4d38]/50 transition duration-200"
//                                         />
//                                     </div>

//                                     <button
//                                         type="submit"
//                                         className="w-full bg-[#23376c] text-white py-3 rounded-lg hover:bg-[#4865b3] transition duration-300 ease-in-out transform hover:scale-[1.02] shadow-lg"
//                                     >
//                                         Submit Application
//                                     </button>
//                                 </div>
//                             </form>

//                             <div className="text-center mt-4">
//                                 <p className="text-sm text-gray-600">
//                                     By submitting, you agree to our
//                                     <a href="#" className="text-[#23376c] ml-1 hover:underline">
//                                         Terms of Service
//                                     </a>
//                                 </p>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className=' mt-[50px] flex flex-col md:flex-row gap-10 md:gap-[60px] justify-between items-center ' >
//                     <div className=' md:w-[50%] flex flex-col gap-3 ' >
//                         <h4 className=' text-[#0e4d38] text-2xl font-semibold ' >Undergraduate, Degree Completion, and Graduate Programs</h4>
//                         <p className=' text-xl ' >For all programs other than the DEMSN, please click the button below to complete your free application.</p>
//                         <button className=' self-start bg-[#23376c] px-8 py-4 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] uppercase '
//                         >Click here to Apply</button>
//                     </div>
//                     <div className=' md:w-[50%] flex flex-col gap-3 ' >
//                         <h4 className=' text-[#0e4d38] text-2xl font-semibold' >Direct Entry Master of Science in Nursing Programs</h4>
//                         <p className=' text-xl ' >For the DEMSN programs in Milwaukee, WI and Mesa, AZ, please click the button below to complete your application.</p>
//                         <button className=' self-start bg-[#23376c] px-8 py-4 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] uppercase '
//                         >Click here to Apply - DEMSN</button>
//                     </div>
//                 </div>

//                 {/* <div className=' flex flex-col items-center justify-center gap-2 mt-5 ' >
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//                     <div className='bg-[#23376c] w-[5px] h-[5px] rounded-full ' ></div>
//             </div> */}

//                 <div className=' mt-[50px]' >
//                     <h2 className={` mb-4 text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase `}>Application Stages</h2>
//                     <ul className=' list-decimal flex flex-col gap-3 text-lg mt-5 md:mt-10 ' >
//                         <li>
//                             Please fill in your personal details in the form above and register as a user. Once registered, you can use your Mobile Number to Login.
//                         </li>
//                         <li>Fill your academic details and upload your documents.</li>
//                         <li>Complete your application form and pay the application fee.</li>
//                         <li>We will send you confirmation email for Interview Date subject to availability.</li>
//                     </ul>
//                 </div>

//                 <div className=' mt-[50px]' >
//                     <h2 className={` mb-4 text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase `}>Placement Stats</h2>
//                     <div className=" py-5 font-poppins ">
//                         <div className="mx-auto max-w-7xl px-6 lg:px-8">
//                             <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
//                                 {stats.map((stat) => (
//                                     <div key={stat.id} className=" bg-[#0e4d38] px-10 py-8 rounded-lg mx-auto flex max-w-xs flex-col gap-y-4">
//                                         <dt className="text-base font-semibold leading-7 text-gray-100">{stat.name}</dt>
//                                         <dd className="order-first text-3xl font-semibold tracking-tight text-gray-50 sm:text-5xl">
//                                             {stat.value}
//                                         </dd>
//                                     </div>
//                                 ))}
//                             </dl>
//                         </div>
//                     </div>
//                 </div>

//                 <div className=' mt-[50px]' >
//                     <h2 className={` mb-5 md:mb-[80px] text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase `}>Placement Partners</h2>
//                     <div className=' w-10/12 mx-auto grid grid-cols-1 md:grid-cols-3 gap-5 ' >
//                         <img src={AmazonImg} className=' w-[250px] ' />
//                         <img src={CiscoIMG} className=' w-[250px] ' />
//                         <img src={IbmImg} className=' w-[250px] ' />
//                         <img src={TataIMG} className=' w-[250px] ' />
//                         <img src={ItImg} className=' w-[250px] ' />
//                         <img src={GodrejImg} className=' w-[250px] ' />
//                     </div>
//                 </div>


//             </div>
//             <SubFooter />
//             <Footer />
//         </div>
//     )
// }

// export default ApplyNow






// import React, { useEffect } from 'react';
// import Footer from '../components/Footer';
// import ApplyImg from "../assets/images/admission.jpeg";
// import AmazonImg from "../assets/amazon.jpg";
// import IbmImg from "../assets/ibm.jpg";
// import CiscoIMG from "../assets/cicsco.jpg";
// import ItImg from "../assets/It.jpg";
// import TataIMG from "../assets/tata.jpg";
// import GodrejImg from "../assets/godrej.jpg";
// import SubFooter from '../components/SubFooter';
// import ApplicationForm from './ApplicationForm';
// import { Link } from "react-router-dom";

// const stats = [
//     { id: 1, name: 'Highest Package', value: '43.5 Lakh' },
//     { id: 2, name: 'Average Package', value: '5.48 Lakh' },
//     { id: 3, name: 'Years of Legacy', value: '14' },
// ];

// const ApplyNow = () => {
//     return (
//         <div className='w-full relative'>
//             <div>
//                 <img src={ApplyImg} className='w-full mb-[30px] mt-[50px] md:mt-[80px]' alt="Apply Now" />
//             </div>

//             <div className='w-10/12 mx-auto flex flex-col gap-5 mb-[50px]'>
//                 <h2 className={`mb-4 text-2xl md:text-5xl tracking-tight font-bold text-center mt-5 md:mt-10 uppercase text-[#0e4d38]`}>Ready for a bright future?</h2>
//                 <div className='w-[15%] mx-auto h-[4px] bg-[#23376c] mt-[-10px] md:mt-[-5px]'></div>
//                 <p className='text-center text-xl mt-5 md:mt-8'>Complete your <strong>online application</strong> and begin your journey to a college where you truly belong.</p>
//                 <p className='text-center md:mt-[-10px] text-lg text-[#23376c]'>Simply create an account or log in to continue a previous application.</p>

//                 <div className="h-screen flex items-center justify-center mt-[-150px] mb-[180px] sm:mt-[-100px] sm:mb-[100px] md:mt-[-150px] md:mb-[180px]">
//                     <div className='w-full mx-auto flex justify-center rounded-md'>
//                         <ApplicationForm />
//                     </div>
//                 </div>

//                 <div className='mt-[50px] flex flex-col md:flex-row gap-10 md:gap-[60px] justify-center items-center'>
//                     <div className='md:w-[50%] flex flex-col gap-3'>
//                         <h4 className='text-[#0e4d38] text-2xl font-semibold'>Undergraduate, Degree Completion, and Graduate Programs</h4>
//                         <p className='text-xl'>For all programs, please click the button below to complete your free application.</p>
//                         <button className='self-start bg-[#23376c] px-8 py-4 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] uppercase'>
//                             <Link
//                                 to="https://admission.maya.edu.in/"
//                                 onClick={() => {
//                                     window.scrollTo(0, 0);
//                                 }}
//                                 className="font-semibold text-white transition-all duration-200 hover:text-yellow-600"
//                             >
//                                 Click Here to Apply
//                             </Link>
//                         </button>
//                     </div>
//                 </div>

//                 <div className='mt-[50px]'>
//                     <h2 className={`mb-4 text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase`}>Application Stages</h2>
//                     <ul className='list-decimal flex flex-col gap-3 text-lg mt-5 md:mt-10'>
//                         <li>Please fill in your personal details in the form above and register as a user. Once registered, you can use your Mobile Number to Login.</li>
//                         <li>Fill your academic details and upload your documents.</li>
//                         <li>Complete your application form and pay the application fee.</li>
//                         <li>We will send you a confirmation email for the Interview Date, subject to availability.</li>
//                     </ul>
//                 </div>

//                 <div className='mt-[50px]'>
//                     <h2 className={`mb-4 text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase`}>Placement Stats</h2>
//                     <div className="py-5 font-poppins">
//                         <div className="mx-auto max-w-7xl px-6 lg:px-8">
//                             <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
//                                 {stats.map((stat) => (
//                                     <div key={stat.id} className="bg-[#0e4d38] px-10 py-8 rounded-lg mx-auto flex max-w-xs flex-col gap-y-4">
//                                         <dt className="text-base font-semibold leading-7 text-gray-100">{stat.name}</dt>
//                                         <dd className="order-first text-3xl font-semibold tracking-tight text-gray-50 sm:text-5xl">
//                                             {stat.value}
//                                         </dd>
//                                     </div>
//                                 ))}
//                             </dl>
//                         </div>
//                     </div>
//                 </div>

//                 <div className='mt-[50px]'>
//                     <h2 className={`mb-5 md:mb-[80px] text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase`}>Placement Partners</h2>
//                     <div className='w-10/12 mx-auto grid grid-cols-1 md:grid-cols-3 gap-5'>
//                         <img src={AmazonImg} className='w-[250px]' />
//                         <img src={CiscoIMG} className='w-[250px]' />
//                         <img src={IbmImg} className='w-[250px]' />
//                         <img src={TataIMG} className='w-[250px]' />
//                         <img src={ItImg} className='w-[250px]' />
//                         <img src={GodrejImg} className='w-[250px]' />
//                     </div>
//                 </div>
//             </div>
//             <SubFooter />
//             <Footer />
//         </div>
//     );
// };

// export default ApplyNow;




import React, { useEffect } from 'react';
import Footer from '../components/Footer';
import ApplyImg from "../assets/images/admission.jpeg";
import AmazonImg from "../assets/amazon.jpg";
import IbmImg from "../assets/ibm.jpg";
import CiscoIMG from "../assets/cicsco.jpg";
import ItImg from "../assets/It.jpg";
import TataIMG from "../assets/tata.jpg";
import GodrejImg from "../assets/godrej.jpg";
import SubFooter from '../components/SubFooter';
import SubSubFooter from '../components/SubSubFooter';
import ApplicationForm from './ApplicationForm';
import { Link } from "react-router-dom";
import NumberAnimation from '../components/numbers/NumberAnimation';
const stats = [
    { id: 1, name: 'Highest Package', value: '43.6 Lakh' },
    { id: 2, name: 'Average Package', value: '5.48 Lakh' },
    { id: 3, name: 'Years of Excellence', value: '15' },
];

const ApplyNow = () => {
    useEffect(() => {
        // Dynamically update script URL to HTTPS
        const script = document.querySelector('script[src="http://cdn.jsinit.directfwd.com/sk-jspark_init.php"]');
        if (script) {
            script.src = script.src.replace('http://', 'https://');
        }
    }, []);

    return (
        <div className='w-full relative'>
            <div>
                <img src={ApplyImg} className='w-full mb-[30px] mt-[50px] md:mt-[80px]' alt="Apply Now" />
            </div>

            <div className='w-10/12 mx-auto flex flex-col gap-5 mb-[50px]'>
                <h2 className={`mb-4 text-2xl md:text-5xl tracking-tight font-bold text-center mt-5 md:mt-10 uppercase text-[#0e4d38]`}>Ready for a bright future?</h2>
                <div className='w-[15%] mx-auto h-[4px] bg-[#23376c] mt-[-10px] md:mt-[-5px]'></div>
                <p className='text-center text-xl mt-5 md:mt-8'>Complete your <strong>online application</strong> and begin your journey to a college where you truly belong.</p>
                <p className='text-center md:mt-[-10px] text-lg text-[#23376c]'>Simply create an account or log in to continue a previous application.</p>

                <div className="h-screen flex items-center justify-center mt-[-150px] mb-[180px] sm:mt-[-100px] sm:mb-[100px] md:mt-[-150px] md:mb-[180px]">
                    <div className='w-full mx-auto flex justify-center rounded-md'>
                        <ApplicationForm />
                    </div>
                </div>

                <div className='mt-[50px] flex flex-col md:flex-row gap-10 md:gap-[60px] justify-center items-center'>
                    <div className='md:w-[50%] flex flex-col gap-3'>
                        <h4 className='text-[#0e4d38] text-2xl font-semibold'>Diploma, UG, PG, Ph.D</h4>
                        <p className='text-xl'>For all programs, please click the button below to complete your free application.</p>
                        <button className='self-start bg-[#23376c] px-8 py-4 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3] uppercase'>
                            <Link
                                to="https://admission.maya.edu.in/"
                                onClick={() => {
                                    window.scrollTo(0, 0);
                                }}
                                className="font-semibold text-white transition-all duration-200 hover:text-yellow-600"
                            >
                                Click Here to Apply
                            </Link>
                        </button>
                    </div>
                </div>

                <div className='mt-[50px]'>
                    <h2 className={`mb-4 text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase`}>Application Stages</h2>
                    <ul className='list-decimal flex flex-col gap-3 text-lg mt-5 md:mt-10'>
                        <li>Please fill in your personal details in the form above and register as a user. Once registered, you can use your Mobile Number to Login.</li>
                        <li>Fill your academic details and upload your documents.</li>
                        <li>Complete your application form and pay the application fee.</li>
                        <li>We will send you a confirmation email for the Interview Date, subject to availability.</li>
                    </ul>
                </div>

                <div className='mt-[50px]'>
                    <h2 className={`mb-4 text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase`}>Placement Stats</h2>
                    <div className="py-5 font-poppins">
                        <div className="mx-auto max-w-7xl px-6 lg:px-8">
                            <dl className="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
                                {stats.map((stat) => (
                                    <div key={stat.id} className="bg-[#0e4d38] px-10 py-8 rounded-lg mx-auto flex max-w-xs flex-col gap-y-4">
                                        <dt className="text-base font-semibold leading-7 text-gray-100">{stat.name}</dt>
                                        <dd className="order-first text-3xl font-semibold tracking-tight text-gray-50 sm:text-5xl">
                                            {stat.value}
                                        </dd>
                                    </div>
                                ))}
                            </dl>
                        </div>
                    </div>
                </div>

                <div className='mt-[50px]'>
                    <h2 className={`mb-5 md:mb-[80px] text-[#0e4d38] text-2xl md:text-4xl font-bold text-center mt-5 md:mt-10 uppercase`}>Placement Partners</h2>
                    <div className='w-10/12 mx-auto grid grid-cols-1 md:grid-cols-3 gap-5'>
                        <img src={AmazonImg} className='w-[250px]' />
                        <img src={CiscoIMG} className='w-[250px]' />
                        <img src={IbmImg} className='w-[250px]' />
                        <img src={TataIMG} className='w-[250px]' />
                        <img src={ItImg} className='w-[250px]' />
                        <img src={GodrejImg} className='w-[250px]' />
                    </div>
                </div>
            </div>
            {/* <SubSubFooter /> */}
            <SubFooter />
            <Footer />
        </div>
    );
};

export default ApplyNow;
